import React, { useState } from "react";
import { Transition, animated } from "react-spring/renderprops";
import { Alert } from "@alm/flow-ds/components";
import { Alert as alertProps } from "records/Alert";
import classnames from "classnames";
import { isRTL } from "utils/getLanguageDir";

interface Props extends alertProps {
	isDesktop: boolean;
	onClose?: (id: string) => void;
}

const WrappedAlert = ({
	className,
	dark,
	description,
	id,
	isDesktop = true,
	list,
	onClose,
	status,
	timeout,
	title,
}: Props) => {
	const [isOpen, setIsOpen] = useState(true);

	// Set animation to come in from the side or bottom based on if it is desktop view or not
	const animate = isDesktop ? "translateX" : "translateY";

	return (
		<>
			<Transition
				// This is triggered when the animation to remove an alert finishes, so calls the onClose prop
				onDestroyed={() => {
					setTimeout(() => {
						if (onClose) onClose(id);
					}, 100);
				}}
				// This is triggered when animation for alert arriving finishes, if timeout prop it will set a timeout to change isOpen, and thus kill the alert
				onRest={() => {
					if (timeout)
						setTimeout(() => {
							if (isOpen) setIsOpen(false);
						}, timeout);
				}}
				native
				config={{ duration: 400 }}
				items={isOpen}
				from={{
					transform: `${animate}(${isRTL() ? "-" : ""}100%)`,
					height: 0,
					opacity: 0,
				}}
				enter={{
					transform: `${animate}(0)`,
					height: "auto",
					opacity: 1,
				}}
				leave={{
					transform: `${animate}(${isRTL() ? "-" : ""}100%)`,
					height: 0,
					opacity: 0,
				}}>
				{isOpen =>
					isOpen &&
					(props => (
						<animated.div key={id} style={props}>
							<Alert
								className={classnames(className, "app-alert")}
								dark={dark}
								description={description}
								list={list}
								onClose={() => setIsOpen(false)}
								status={status}
								title={title}
							/>
						</animated.div>
					))
				}
			</Transition>
		</>
	);
};

export default WrappedAlert;
